import {
  AZURE_USERS_RESET,
  AZURE_USERS_LOADING,
  AZURE_USERS_SUCCESS,
  AZURE_USERS_APPEND,
  AZURE_USERS_ERROR,
  AZURE_USER_DETAILS_LOADING,
  AZURE_USER_DETAILS_SUCCESS,
  AZURE_USER_DETAILS_ERROR,
  AZURE_USER_DETAILS_RESET,
  AZURE_GROUPS_LOADING,
  AZURE_GROUPS_SUCCESS,
  AZURE_GROUPS_ERROR,
  AZURE_SKUS_LOADING,
  AZURE_SKUS_SUCCESS,
  AZURE_SKUS_ERROR,
  AZURE_DOMAINS_LOADING,
  AZURE_DOMAINS_SUCCESS,
  AZURE_DOMAINS_ERROR,
} from "../../actions/userManagement/azureUsers";

const initialState: any = {
  Data: {
    data: [],
    meta: { continuationToken: null, hasMore: false, status: "all", search: null },
    loading: false,
    error: null,
  },
  UserDetails: {
    data: null,
    loading: false,
    error: null,
  },
  Groups: {
    data: null,
    loading: false,
    error: null,
  },
  Skus: {
    data: null,
    loading: false,
    error: null,
  },
  Domains: {
    data: [],
    loading: false,
    error: null,
  },
};

export default function azureUserReducer(state = initialState, action: any) {
  switch (action.type) {
    case AZURE_USERS_RESET:
      return {
        ...state,
        Data: {
          ...state.Data,
          data: [],
          meta: {
            continuationToken: null,
            hasMore: false,
            status: "all",
            search: null,
          },
          error: null,
        },
      };

    case AZURE_USERS_LOADING:
      return {
        ...state,
        Data: {
          ...state.Data,
          loading: action.payload,
          error: null,
        },
      };

    case AZURE_USERS_SUCCESS:
      return {
        ...state,
        Data: {
          ...state.Data,
          loading: false,
          data: action.payload.data,
          meta: action.payload.meta,
          error: null,
        },
      };

    case AZURE_USERS_APPEND:
      return {
        ...state,
        Data: {
          ...state.Data,
          loading: false,
          data: [...(state.Data.data || []), ...(action.payload.data || [])],
          meta: action.payload.meta,
          error: null,
        },
      };

    case AZURE_USERS_ERROR:
      return {
        ...state,
        Data: {
          ...state.Data,
          loading: false,
          error: action.payload,
        },
      };

    case AZURE_USER_DETAILS_RESET:
      return {
        ...state,
        UserDetails: {
          data: null,
          loading: false,
          error: null,
        },
      };

    case AZURE_USER_DETAILS_LOADING:
      return {
        ...state,
        UserDetails: {
          ...state.UserDetails,
          loading: action.payload,
          error: null,
        },
      };

    case AZURE_USER_DETAILS_SUCCESS:
      return {
        ...state,
        UserDetails: {
          ...state.UserDetails,
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case AZURE_USER_DETAILS_ERROR:
      return {
        ...state,
        UserDetails: {
          ...state.UserDetails,
          loading: false,
          error: action.payload,
        },
      };

    case AZURE_GROUPS_LOADING:
      return {
        ...state,
        Groups: {
          ...state.Groups,
          loading: action.payload,
          error: null,
        },
      };

    case AZURE_GROUPS_SUCCESS:
      return {
        ...state,
        Groups: {
          ...state.Groups,
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case AZURE_GROUPS_ERROR:
      return {
        ...state,
        Groups: {
          ...state.Groups,
          loading: false,
          error: action.payload,
        },
      };

    case AZURE_SKUS_LOADING:
      return {
        ...state,
        Skus: {
          ...state.Skus,
          loading: action.payload,
          error: null,
        },
      };

    case AZURE_SKUS_SUCCESS:
      return {
        ...state,
        Skus: {
          ...state.Skus,
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case AZURE_SKUS_ERROR:
      return {
        ...state,
        Skus: {
          ...state.Skus,
          loading: false,
          error: action.payload,
        },
      };

    case AZURE_DOMAINS_LOADING:
      return {
        ...state,
        Domains: {
          ...state.Domains,
          loading: action.payload,
          error: null,
        },
      };

    case AZURE_DOMAINS_SUCCESS:
      return {
        ...state,
        Domains: {
          ...state.Domains,
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case AZURE_DOMAINS_ERROR:
      return {
        ...state,
        Domains: {
          ...state.Domains,
          loading: false,
          error: action.payload,
        },
      };
    default:
      return state;
  }
}